import Post from './api'

// 转发请求
const transToReq = (funcNasme, params) => {
  const _param = {
    mod: 'root',
    platid: Number(localStorage.getItem('platId')),
    app_id: params.app_id,
    param: {
      _check: '',
      _func: funcNasme,
      _mod: 'manager',
      _param: params
    }
  }
  return Post('TransTopReq', _param)
}

export default transToReq